export const GET_ALLCONTRIES = 'GET_ALLCONTRIES'
export const GET_ALL_ACTIVITIES = 'GET_ALL_ACTIVITIES'
export const GET_CONTRY_DETAIL = 'GET_CONTRY_DETAIL'
export const GET_CONTRY_BY_NAME = 'GET_CONTRY_BY_NAME'
export const FILTER_BY_CONTINENTS = 'FILTER_BY_CONTINENTS'
export const FILTER_BY_ACTIVITIES = 'FILTER_BY_ACTIVITIES'
export const ORDER_BY_NAME= 'ORDER_BY_NAME'
export const ORDER_BY_POPULATION= 'ORDER_BY_POPULATION'
